import createIcon from '../../createIcon';

/**
 * @component @name AddToHomeScreen
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguNSAxLjAxTDguNSAxQzcuNCAxIDYuNSAxLjkgNi41IDNWNkg4LjVWNUgxOC41VjE5SDguNVYxOEg2LjVWMjFDNi41IDIyLjEgNy40IDIzIDguNSAyM0gxOC41QzE5LjYgMjMgMjAuNSAyMi4xIDIwLjUgMjFWM0MyMC41IDEuOSAxOS42IDEuMDEgMTguNSAxLjAxWk0xMC41IDE1SDEyLjVWOEg1LjVWMTBIOS4wOUwzLjUgMTUuNTlMNC45MSAxN0wxMC41IDExLjQxVjE1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AddToHomeScreen = createIcon('AddToHomeScreen', [
  [
    'path',
    {
      d: 'M18.5 1.01L8.5 1C7.4 1 6.5 1.9 6.5 3V6H8.5V5H18.5V19H8.5V18H6.5V21C6.5 22.1 7.4 23 8.5 23H18.5C19.6 23 20.5 22.1 20.5 21V3C20.5 1.9 19.6 1.01 18.5 1.01ZM10.5 15H12.5V8H5.5V10H9.09L3.5 15.59L4.91 17L10.5 11.41V15Z',
      key: '1djxlp',
    },
  ],
]);

export default AddToHomeScreen;
